import React from 'react';
import { AntdColumn } from '../../../../types/common/table';
import { HomeTab } from '../../../../types/home/tab';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import Switch from '../../../../components/input/Switch';
import { HOME_TAB_LINK_TYPE_V2, HOME_TAB_STATUS_TYPE_V2 } from '../../../../constants/service/app/homeConstantsV2';
import { ValueOf } from '../../../../types/common/utils';
import Anchor from '../../../../components/link/Anchor';
import moment from '../../../../lib/moment';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { DateRageType } from '../../../../types/common/date';
import { Link } from '../../../../types/common/link';
import { makeDetailPageUrl } from '../../../../lib/utils/urlUtils';
import {
  MAIN_PAGE_MANAGEMENT_URL_PATH,
  SUB_PAGE_MANAGEMENT_URL_PATH,
} from '../../../../constants/service/common/urlConstants';
import Button from '../../../../components/Button';

const linkUrlFactory = (link: Link & { type: ValueOf<typeof HOME_TAB_LINK_TYPE_V2> }): string | undefined => {
  switch (link.type) {
    case HOME_TAB_LINK_TYPE_V2.MAIN:
      return MAIN_PAGE_MANAGEMENT_URL_PATH;
    case HOME_TAB_LINK_TYPE_V2.SUB_PAGE:
      if (link?.id) return makeDetailPageUrl(SUB_PAGE_MANAGEMENT_URL_PATH, link.id);
      return;
    default:
      return;
  }
};

export const columns = (props: {
  onChangeTabStatus: (id: number, checked: boolean) => void;
  onClickEdit: (id: number) => void;
}): AntdColumn<HomeTab>[] => {
  const { onChangeTabStatus, onClickEdit } = props;
  return [
    { title: <TableColumnTitle title="순서" />, dataIndex: 'no', width: 50 },
    {
      title: <TableColumnTitle title="활성" />,
      dataIndex: 'status',
      width: 70,
      render: (value: ValueOf<typeof HOME_TAB_STATUS_TYPE_V2>, record: HomeTab) =>
        record.linkType === HOME_TAB_LINK_TYPE_V2.MAIN ? (
          <></>
        ) : (
          <Switch
            checked={value === HOME_TAB_STATUS_TYPE_V2.ACTIVE}
            onChange={(checked): void => onChangeTabStatus(record.id, checked)}
          />
        ),
    },
    { title: <TableColumnTitle title="탭 ID" />, dataIndex: 'id', width: 50 },
    { title: <TableColumnTitle title="타이틀" />, dataIndex: 'title', width: 150 },
    {
      title: <TableColumnTitle title="연결링크" />,
      dataIndex: 'link',
      width: 200,
      render: (link: Link, record): React.JSX.Element => {
        // 탭 생성 시 LinkId 연결을 하지 않아 어드민 내 링크가 없는 경우 ex)웹페이지 - 추천 탭
        if (!linkUrlFactory({ ...link, type: record.linkType })) return <div>{'-'}</div>;
        return (
          <Anchor
            color="primary"
            isUnderLine
            text={`${link.name}(${link.id})`}
            href={linkUrlFactory({ ...link, type: record.linkType })}
            target="_blank"
          />
        );
      },
    },
    {
      title: <TableColumnTitle title="노출기간" />,
      dataIndex: 'period',
      width: 250,
      render: (period: DateRageType) => (
        <>
          {period?.startDate && period?.endDate
            ? `${moment(period.startDate).format(DATE_FORMAT.FULL_DASH_FORMAT)} ~ ${moment(period.endDate).format(
                DATE_FORMAT.FULL_DASH_FORMAT,
              )}`
            : '무기한'}
        </>
      ),
    },
    { title: <TableColumnTitle title="메모" />, dataIndex: 'memo', width: 200 },
    {
      title: <TableColumnTitle title="편집" />,
      width: 100,
      dataIndex: 'id',
      render: (id: number, record) =>
        record.linkType === HOME_TAB_LINK_TYPE_V2.MAIN ? (
          <></>
        ) : (
          <Button isRadius color="black" text="편집" onClick={(): void => onClickEdit(id)} />
        ),
    },
  ];
};
